{{#if uvcInstancesWithoutDimensionsWithAgentHandles.length}}
{{> (partial "harness/generate-initial") harness=. uvcInstanceAndAgentHandles=uvcInstancesWithoutDimensionsWithAgentHandles}}
{{/if}}
{{#each dimensionPropertiesListWithUvcInstanceAndAgentHandles ln=uvcInstancesWithoutDimensionsWithAgentHandles.length delimeter="\n"}}
{{> (partial "harness/generate-initial") harness=.. dimensionPropertiesList=dimensionPropertiesList blockNamePrefix=blockNamePrefixes.resources interfaceBlockNamePrefix=blockNamePrefixes.instances uvcInstanceAndAgentHandles=uvcInstanceAndAgentHandles}}
{{/each}}
